import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class AppearAnimation {
  constructor({
                scrollerSelector = null,       // ex: ".app-scroll" si tu as un wrapper qui scrolle
                start = "top 75%", end = "bottom 30%",
              } = {}) {
    this._elements = gsap.utils.toArray("[appear-animation]");
    this._scroller = scrollerSelector ? document.querySelector(scrollerSelector) : window;

    if (this._elements.length) {
      // Si tu as un scroller custom (overflow auto), indique-le à ScrollTrigger
      if (this._scroller !== window) {
        ScrollTrigger.defaults({scroller: this._scroller});
      }

      this.init({start, end});
      this._setupRefreshGuards();
    }
  }

  init({start, end}) {
    this._elements.forEach((element) => {
      element.style.opacity = 0;
      const delayAttr = parseFloat(element.getAttribute("appear-delay"));
      const delay = Number.isFinite(delayAttr) ? delayAttr : 0;

      gsap.fromTo(element, {opacity: 0, y: 70}, {
        opacity: 1,
        y: 0,
        ease: "power1.out",
        duration: 0.6,
        delay,
        scrollTrigger: {
          trigger: element, start, end,
          scrub: false, toggleActions: "play none none reverse", markers: false, invalidateOnRefresh: true,
        },
      });
    });
  }

  _setupRefreshGuards() {
    // 1) refresh après webfonts
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => ScrollTrigger.refresh());
    }

    // 3) refresh sur resize de containers (évite les drifts à la volée)
    if ("ResizeObserver" in window) {
      const ro = new ResizeObserver(() => ScrollTrigger.refresh());
      ro.observe(document.body);
    }

    // 5) au chargement complet
    window.addEventListener("load", () => ScrollTrigger.refresh());
  }
}
